<template>
	<div>
		<h1>Chat Rooms</h1>
		<h3 class="pt-3">General Public Chat Rooms</h3>
		<div style="display: flex; flex-direction: column">
			<v-row>
				<v-col :cols="addCard || editCard ? 6 : 12" class="d-flex flex-column">
					<v-card>
						<v-card-title>
							<v-card-subtitle>
								<v-btn color="primary" class="ma-2 white--text" @click="changeToAddForm()">
									Add
									<v-icon right dark>mdi-plus</v-icon>
								</v-btn>
							</v-card-subtitle>
						</v-card-title>
						<v-card-text>
							<v-data-table
								:headers="headers"
								:items="chatRooms"
								sort-by="name"
								no-data-text="No public chat rooms to show, please create one first."
							>
								<template v-slot:item.actions="{ item }">
									<v-icon small class="mr-2" @click="changeToEditForm(item)">mdi-pencil</v-icon>
									<v-icon small @click="chatRoomDelete(item)">mdi-delete</v-icon>
								</template>
							</v-data-table>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6" v-if="addCard" class="d-flex flex-column">
					<v-form ref="addForm" v-model="validAddForm">
						<v-card>
							<v-card-title>
								Create New Chat
								<v-spacer></v-spacer>
								<v-btn
									text
									class="ma-2"
									@click="
										addCard = false;
										resetForms();
									"
								>
									Close
									<v-icon right>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Name</v-col>
									<v-col cols="9">
										<v-text-field v-model="addRoom.name" :rules="fieldRules" outlined counter maxlength="100"></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Moderator Email</v-col>
									<v-col cols="9">
										<v-text-field v-model="addRoom.adminEmail" :rules="emailRules" outlined counter maxlength="100"></v-text-field>
									</v-col>
								</v-row>
							</v-card-text>
							<v-card-actions class="justify-end">
								<v-btn :disabled="!validAddForm" color="primary" @click="chatRoomCreate()">Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-col>
				<v-col cols="6" v-if="editCard" class="d-flex flex-column">
					<v-form ref="editForm" v-model="validEditForm">
						<v-card>
							<v-card-title>
								Update Chat Room
								<v-spacer></v-spacer>
								<v-btn
									text
									class="ma-2"
									@click="
										editCard = false;
										resetForms();
									"
								>
									Close
									<v-icon right>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Name</v-col>
									<v-col cols="9">
										<v-text-field
											v-model="editRoom.name"
											:value="editRoom.name"
											:rules="fieldRules"
											outlined
											counter
											maxlength="100"
										></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Moderator Email</v-col>
									<v-col cols="9">
										<v-text-field v-model="editRoom.adminEmail" :rules="emailRules" outlined counter maxlength="100" :value="editRoom.adminEmail"></v-text-field>
									</v-col>
								</v-row>
							</v-card-text>
							<v-card-actions class="justify-end">
								<v-btn :disabled="!validEditForm" color="primary" @click="chatRoomEdit()">Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-col>
			</v-row>

			<h3 class="pt-3">Private Group Chat Room</h3>
			<v-row>
				<v-col :cols="addCardPrivate || editCardPrivate ? 6 : 12" class="d-flex flex-column">
					<v-card>

						<v-card-title>
							<v-card-subtitle>
								<v-btn color="primary" class="ma-2 white--text" @click="changeToAddFormPrivate()">
									Add
									<v-icon right dark>mdi-plus</v-icon>
								</v-btn>
							</v-card-subtitle>
						</v-card-title>
						
						<v-card-text>
							<v-data-table
								:headers="headers"
								:items="chatRoomsPrivate"
								sort-by="name"
								no-data-text="No private chat rooms to show, please create one first."
							>
								<template v-slot:item.actions="{ item }">
									<v-icon small class="mr-2" @click="changeToEditFormPrivate(item)">mdi-pencil</v-icon>
									<v-icon small @click="chatRoomDeletePrivate(item)">mdi-delete</v-icon>
								</template>
							</v-data-table>
						</v-card-text>

					</v-card>
				</v-col>

				<v-col cols="6" v-if="addCardPrivate" class="d-flex flex-column">
					<v-form ref="addFormPrivate" v-model="validAddFormPrivate">
						<v-card>
							<v-card-title>
								Create New Chat
								<v-spacer></v-spacer>
								<v-btn
									text
									class="ma-2"
									@click="
										addCardPrivate = false;
										resetFormsPrivate();
									"
								>
									Close
									<v-icon right>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Name</v-col>
									<v-col cols="9">
										<v-text-field v-model="addRoomPrivate.name" :rules="fieldRules" outlined counter maxlength="100"></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Moderator Email</v-col>
									<v-col cols="9">
										<v-text-field v-model="addRoomPrivate.adminEmail" :rules="emailRules" outlined counter maxlength="100"></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="font-weight-bold">
										Input participant email (separated by new line)
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-textarea v-model="addRoomPrivate.participantEmail"></v-textarea>
									</v-col>
								</v-row>
								
							</v-card-text>
							<v-card-actions class="justify-end">
								<v-btn :disabled="!validAddFormPrivate" color="primary" @click="chatRoomCreatePrivate()">Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-col>

				<v-col cols="6" v-if="editCardPrivate" class="d-flex flex-column">
					<v-form ref="editFormPrivate" v-model="validEditFormPrivate">
						<v-card>
							<v-card-title>
								Update Chat Room
								<v-spacer></v-spacer>
								<v-btn
									text
									class="ma-2"
									@click="
										editCardPrivate = false;
										resetFormsPrivate();
									"
								>
									Close
									<v-icon right>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Name</v-col>
									<v-col cols="9">
										<v-text-field
											v-model="editRoomPrivate.name"
											:value="editRoomPrivate.name"
											:rules="fieldRules"
											outlined
											counter
											maxlength="100"
										></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="3" class="font-weight-bold">Moderator Email</v-col>
									<v-col cols="9">
										<v-text-field v-model="editRoomPrivate.adminEmail" :rules="emailRules" outlined counter maxlength="100" :value="editRoomPrivate.adminEmail"></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="font-weight-bold">
										Input participant email (separated by new line)
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-textarea v-model="editRoomPrivate.participantEmail"></v-textarea>
									</v-col>
								</v-row>
							</v-card-text>
							<v-card-actions class="justify-end">
								<v-btn :disabled="!validEditFormPrivate" color="primary" @click="chatRoomEditPrivate()">Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-col>
			</v-row>

			<h3 class="pt-3">Unreferenced Presentation Chat Rooms</h3>
			<v-row
				><v-col :cols="12" class="d-flex flex-column">
					<v-card>
						<v-card-text>
							<v-data-table
								:headers="headers"
								:items="orphanPresentationChatRooms"
								sort-by="name"
								no-data-text="No unreferenced presentation chat rooms to show."
							>
								<template v-slot:item.actions="{ item }">
									<v-icon small @click="chatRoomCometChatDelete(item)">mdi-delete</v-icon>
								</template>
							</v-data-table>
						</v-card-text>
					</v-card>
				</v-col></v-row
			>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	components: {},
	data() {
		return {
			headers: [
				{
					text: "GUID",
					sortable: false,
					value: "guid",
				},
				{
					text: "Name",
					sortable: false,
					value: "name",
				},
				{
					text: "Actions",
					sortable: false,
					value: "actions",
				},
			],
			chatRooms: [],
			chatRoomsPrivate: [],
			orphanPresentationChatRooms: [],
			validAddForm: false,
			validAddFormPrivate: false,
			addCard: false,
			addCardPrivate: false,
			fieldRules: [
				(v) => (!!v && /.*[^ ].*/.test(v)) || "Please fill out this field",
				(v) => (v && !/[^a-zA-Z0-9 ]/.test(v)) || "Only letters, numbers and spaces are allowed",
			],
			emailRules: [
				(v) => (!!v && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) || "Not a valid email",
			],
			addRoom: {
				name: null,
			},
			addRoomPrivate: {
				name: null,
				adminEmail: "",
				participantEmail: "",
			},
			validEditForm: false,
			validEditFormPrivate: false,
			editCard: false,
			editCardPrivate: false,
			editRoom: {
				guid: null,
				guidCometChat: null,
				guidVChat: null,
				name: null,
			},
			editRoomPrivate: {
				guid: null,
				guidCometChat: null,
				guidVChat: null,
				name: null,
			},
		};
	},
	props: ["experienceId"],
	created: function () {
	},
	mounted: function () {
		this.getChatRooms();
		this.getUnreferencedPresentationChatRooms();
		this.getPrivateChatRooms();
	},
	methods: {
		getPrivateChatRooms() {
			axios.get("/system/generalPrivateChatRoom/list?experienceId=" + this.experienceId).then((response) => {
				if (response.data) {
					this.chatRoomsPrivate = response.data;
				}
			});
		},
		getChatRooms() {
			axios.get("/system/generalPublicChatRoom/list?experienceId=" + this.experienceId).then((response) => {
				if (response.data) {
					this.chatRooms = response.data;
				}
			});
		},
		getUnreferencedPresentationChatRooms() {
			axios.get("/system/UnreferencePresentationChatRooms/list?experienceId=" + this.experienceId).then((response) => {
				if (response.data) {
					for (let presentation of response.data) {
						console.log(presentation);
						this.orphanPresentationChatRooms.push({
							id : presentation.id,
							guid: presentation.groupChatId,
							name: presentation.title,
							actions: "-",
						});
					}
				}
			});
		},
		
		changeToAddForm() {
			this.addCard = true;
			this.editCard = false;
			this.resetForms();
		},
		changeToAddFormPrivate() {
			this.addCardPrivate = true;
			this.editCardPrivate = false;
			this.resetFormsPrivate();
		},
		changeToEditForm(item) {
			this.editCard = true;
			this.addCard = false;
			this.editRoom.name = item.name;
			this.editRoom.adminEmail = item.adminEmail;
			this.editRoom.guid = item.guid;
			this.editRoom.guidCometChat = item.guidCometChat;
			this.editRoom.guidVChat = item.guidVChat;
			if (this.$refs.addForm != undefined) {
				this.$refs.addForm.reset();
			}
			console.log("to be edited: ", item);
		},
		changeToEditFormPrivate(item) {
			this.editCardPrivate = true;
			this.addCardPrivate = false;
			this.editRoomPrivate.name = item.name;
			this.editRoomPrivate.guid = item.guid;
			this.editRoomPrivate.guidVChat = item.guidVChat;
			
			this.editRoomPrivate.adminEmail = item.adminEmail;
			this.editRoomPrivate.participantEmail = item.participantEmail.replaceAll("[","").replaceAll(", ","\n").replaceAll("]","");


			if (this.$refs.addFormPrivate != undefined) {
				this.$refs.addFormPrivate.reset();
			}
			console.log("to be edited: ", item);
		},
		resetForms() {
			if (this.$refs.addForm != undefined) {
				this.$refs.addForm.reset();
			}

			if (this.$refs.editForm != undefined) {
				this.$refs.editForm.reset();
			}
		},
		resetFormsPrivate() {
			if (this.$refs.addFormPrivate != undefined) {
				this.$refs.addFormPrivate.reset();
			}

			if (this.$refs.editFormPrivate != undefined) {
				this.$refs.editFormPrivate.reset();
			}
		},
		chatRoomCreate() {
			let guid = this.toHexString(this.addRoom.name);
			let name = this.addRoom.name;
			let adminEmail = this.addRoom.adminEmail;
			let type = "public";
			let experienceId = this.experienceId;
			let metadata = {
				type: "General Public",
				experienceId: experienceId,
			};

			axios
				.post("/system/generalPublicChatRoom/add", {
					experienceId,
					guid,
					name,
					type,
					metadata,
					adminEmail
				})
				.then((response) => {
					console.log("Group added successfully: ", response);
					this.$refs.addForm.reset();
					this.getChatRooms();
					this.getUnreferencedPresentationChatRooms();
				});
		},
		chatRoomCreatePrivate() {
			let guid = this.toHexString(this.addRoomPrivate.name);
			let name = this.addRoomPrivate.name;
			let adminEmail = this.addRoomPrivate.adminEmail;
			let participantEmail = this.addRoomPrivate.participantEmail;
			let type = "private";
			let experienceId = this.experienceId;
			let metadata = {
				type: "General Private",
				experienceId: experienceId,
			};

			axios
				.post("/system/generalPrivateChatRoom/add", {
					experienceId,
					guid,
					name,
					type,
					metadata,
					adminEmail,
					participantEmail
				})
				.then((response) => {
					console.log("Group added successfully: ", response);
					this.$refs.addFormPrivate.reset();
					this.getPrivateChatRooms();
				});
		},
		chatRoomEdit() {
			let guidCometChat = this.editRoom.guidCometChat;
			let guidVChat = this.editRoom.guidVChat;
			let name = this.editRoom.name;
			let experienceId = this.experienceId;
			let adminEmail = this.editRoom.adminEmail;
			let chatOnLobby = true;
			let boothSetup = false;

			axios.post("/system/generalPublicChatRoom/edit", { experienceId, guidCometChat, guidVChat, name, chatOnLobby, boothSetup, adminEmail }).then((response) => {
				console.log("Group edited successfully: ", response);
				this.getChatRooms();
				this.getUnreferencedPresentationChatRooms();
			});
		},
		chatRoomEditPrivate() {
			let guidVChat = this.editRoomPrivate.guidVChat;
			let name = this.editRoomPrivate.name;
			let experienceId = this.experienceId;
			let adminEmail = this.editRoomPrivate.adminEmail;
			let participantEmail = this.editRoomPrivate.participantEmail;

			axios.post("/system/generalPrivateChatRoom/edit", { experienceId, guidVChat, name, adminEmail, participantEmail }).then((response) => {
				console.log("Group edited successfully: ", response);
				this.getPrivateChatRooms();
			});
		},
		chatRoomDelete(item) {
			let id = item.id;

			confirm("Are you sure you want to delete " + item.name + " chat room?") &&
				axios.post("/system/generalPublicChatRoom/delete", { id }).then((response) => {
					console.log("Group deleted successfully: ", response);
					this.getChatRooms();
					this.getUnreferencedPresentationChatRooms();
				});

			if (this.editCard) {
				this.editCard = false;
			}
		},
		chatRoomDeletePrivate(item) {
			let id = item.id;

			confirm("Are you sure you want to delete " + item.name + " chat room?") &&
				axios.post("/system/generalPrivateChatRoom/delete", { id }).then((response) => {
					console.log("Group deleted successfully: ", response);
					this.getPrivateChatRooms();
				});

			if (this.editCard) {
				this.editCard = false;
			}
		},
		chatRoomCometChatDelete(item) {
			confirm("Are you sure you want to delete " + item.name + " chat room?") &&
				axios.post("/system/unreferencedPresentationChatRooms/delete", { 
						experienceId: this.experienceId, 
						id: item.id, 
						guid: item.guid 
				}).then((response) => {
					console.log("Group deleted successfully: ", response);
					this.getChatRooms();
					this.getUnreferencedPresentationChatRooms();
				});

			if (this.editCard) {
				this.editCard = false;
			}
		},
		async listPresentation() {
			return axios
				.post("/system/presentation/list/without/schedule", {
					experienceId: this.experienceId,
				})
				.then((response) => {
					return (this.presentationList = response.data);
				})
				.catch(() => {});
		},
		toHexString(text) {
			let result = "";
			for (let i = 0; i < text.length; i++) {
				result += text.charCodeAt(i).toString(16);
			}

			result = this.experienceId + "-" + result;

			if (result.length > 100) {
				result = result.substring(0, 100);
			}
			return result;
		},
		isValidBulkEmail(value) {
			for (const email of value.split("\n")) {
				if (!email.trim().match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
					return false;
				}
			}
			return true;
		}
	},
};
</script>